@if (showFooter()) {
  <div
    class="tw-flex tw-items-center tw-gap-2 tw-border-t tw-border-neutral-300 tw-bg-white tw-p-4"
  >
    <!-- Secondary (left) -->
    <button
      class="tw-btn-medium tw-btn-secondary-filled"
      type="button"
      [class.tw-invisible]="!drawer().buttons.secondaryButton.visible"
      [class.tw-hidden]="!drawer().buttons.secondaryButton.visible"
      (click)="secondaryButtonClicked()"
    >
      {{ drawer().buttons.secondaryButton.label }}
    </button>

    <!-- Tertiary (middle) -->
    <button
      class="tw-btn-medium tw-btn-tertiary"
      type="button"
      [class.tw-invisible]="!drawer().buttons.tertiaryButton.visible"
      [class.tw-hidden]="!drawer().buttons.tertiaryButton.visible"
      (click)="tertiaryButtonClicked()"
    >
      {{ drawer().buttons.tertiaryButton.label }}
    </button>

    <!-- Primary (right, always fills remaining space) -->
    <div class="tw-flex tw-flex-1 tw-justify-end">
      <button
        class="tw-btn-primary tw-btn-medium tw-w-full"
        type="button"
        (click)="primaryButtonClicked()"
      >
        @if (!drawer().processing) {
          {{ drawer().buttons.primaryButton.label }}
        } @else {
          <da-icon icon="arrow-path" class="tw-size-4 tw-animate-spin" />
        }
      </button>
    </div>
  </div>
}
